import { render, staticRenderFns } from "./CommentCard.vue?vue&type=template&id=e6e30fc6&scoped=true&"
import script from "./CommentCard.vue?vue&type=script&lang=js&"
export * from "./CommentCard.vue?vue&type=script&lang=js&"
import style0 from "./CommentCard.vue?vue&type=style&index=0&id=e6e30fc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e30fc6",
  null
  
)

export default component.exports